import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AppButtonComponent } from "../../../../Common/Components/Button/ButtonComponent";
import { AuditEffects } from "../../State/AuditEffects";
import { AuditState } from "../../State/AuditState";
import { AuditWithSession } from "../../Dto/AuditModel";

@Component({
  selector: "app-audit-edit",
  standalone: true,
  imports: [AppButtonComponent],
  templateUrl: "./AuditViewPage.html",
  styleUrl: "./AuditViewPage.scss",
})
export class AuditViewPage implements OnInit {
  private readonly auditEffects = inject(AuditEffects);
  readonly auditState = inject(AuditState);
  private readonly router = inject(Router);

  audit: AuditWithSession | null = null;

  ngOnInit(): void {
    this.resoleveAuditFromNavigation();
  }

  private resoleveAuditFromNavigation(): void {
    const state = this.router.getCurrentNavigation()?.extras?.state ?? history.state;
    const audit = state?.["audit"] as AuditWithSession | undefined;

    if (!audit) {
      this.router.navigate(["/audits"]).catch(() => undefined);
      return;
    }

    this.audit = audit;
  }

  goBack(): void {
    this.router.navigate(["/audits"]);
  }

  formatDate(dateString: string | undefined | null): string {
    if (!dateString) {
      return "N/A";
    }
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  }

  formatJson(jsonString: string | undefined | null): string {
    if (!jsonString) {
      return "{}";
    }
    try {
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch (error: unknown) {
      console.error("Failed to parse JSON string:", error);
      return jsonString || "{}";
    }
  }
}
